import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const bookConfig: BookPageConfig = {
  theme: {
    quoteColor: 'rgba(228, 88, 127, 0.22)',
    tocLockColor: brandTheme.primaryColor,
  },
  texts: commonTexts,
}
